/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ChuangYiChaXunTiaoJian,
  ChuangYiChuangJianGengXinXinXi,
  ChuangYiZhuangTaiGengXinXinXi,
  ResponseApiChuangYiXiangQing,
  ResponseApiIPageChuangYiLieBiao,
  ResponseApiLong,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class GuangGaoChuangYiGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags GuangGaoChuangYiGuanLi
   * @name CreativeListUsingPost
   * @summary 分页查询创意列表
   * @request POST:/dsp-admin/api/creative
   * @secure
   */
  creativeListUsingPost = (
    查询条件参数: ChuangYiChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageChuangYiLieBiao, void>({
      path: `/dsp-admin/api/creative`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoChuangYiGuanLi
   * @name CreateCreativeUsingPost
   * @summary 创建广告创意
   * @request POST:/dsp-admin/api/creative/create
   * @secure
   */
  createCreativeUsingPost = (
    createDTO: ChuangYiChuangJianGengXinXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/creative/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 支持单个或批量更新创意状态。状态值：0-删除, 1-投放中, 2-暂停, 3-已完成
   *
   * @tags GuangGaoChuangYiGuanLi
   * @name UpdateCreativeStatusUsingPut
   * @summary 更新创意状态
   * @request PUT:/dsp-admin/api/creative/status
   * @secure
   */
  updateCreativeStatusUsingPut = (
    updateDTO: ChuangYiZhuangTaiGengXinXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/creative/status`,
      method: "PUT",
      body: updateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoChuangYiGuanLi
   * @name GetCreativeUsingPost
   * @summary 获取广告创意详情
   * @request POST:/dsp-admin/api/creative/{id}
   * @secure
   */
  getCreativeUsingPost = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiChuangYiXiangQing, void>({
      path: `/dsp-admin/api/creative/${id}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoChuangYiGuanLi
   * @name UpdateCreativeUsingPut
   * @summary 更新广告创意
   * @request PUT:/dsp-admin/api/creative/{id}
   * @secure
   */
  updateCreativeUsingPut = (
    createDTO: ChuangYiChuangJianGengXinXinXi,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/creative/${id}`,
      method: "PUT",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoChuangYiGuanLi
   * @name DeleteCreativeUsingDelete
   * @summary 删除广告创意
   * @request DELETE:/dsp-admin/api/creative/{id}
   * @secure
   */
  deleteCreativeUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/creative/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoChuangYiGuanLi
   * @name ApproveCreativeUsingPut
   * @summary 审核通过创意
   * @request PUT:/dsp-admin/api/creative/{id}/approve
   * @secure
   */
  approveCreativeUsingPut = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/creative/${id}/approve`,
      method: "PUT",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoChuangYiGuanLi
   * @name RejectCreativeUsingPut
   * @summary 审核拒绝创意
   * @request PUT:/dsp-admin/api/creative/{id}/reject
   * @secure
   */
  rejectCreativeUsingPut = (
    id?: number,
    query?: {
      /** 拒绝原因 */
      comment?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/creative/${id}/reject`,
      method: "PUT",
      query: query,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new GuangGaoChuangYiGuanLi();
